import React, { useState, useEffect } from 'react'

export const MyCart = () => {
    return <div>
        <h1>My Cart Page</h1>
    </div>
}